import React from 'react';
import { Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-mimate-text text-mimate-bg py-16" data-id="element-42">
      <div className="container mx-auto px-6 flex flex-col items-center text-center" data-id="element-43">
        {/* Instagram Section */}
        <h3 className="text-2xl font-heading mb-4" data-id="element-44">Síguenos en Instagram</h3>
        <a href="https://www.instagram.com/salon_unas_vale?utm_source=qr&igsh=MWh2Zno2NnBtZXZ1bg==" target="_blank" rel="noopener noreferrer" className="w-16 h-16 rounded-full bg-mimate-bg/10 flex items-center justify-center hover:bg-mimate-primary transition-colors mb-2" aria-label="Instagram" data-id="element-45">
          <Instagram size={32} data-id="element-46" />
        </a>
        <a href="https://www.instagram.com/salon_unas_vale?utm_source=qr&igsh=MWh2Zno2NnBtZXZ1bg==" target="_blank" rel="noopener noreferrer" className="text-mimate-bg/70 hover:text-mimate-primary transition-colors text-sm mb-10" data-id="element-47">
          @salon_unas_vale
        </a>

        {/* Divider */}
        <div className="w-24 h-px bg-mimate-bg/20 mb-8" data-id="element-48"></div>

        {/* Logo & Copyright */}
        <img src="https://cdn.magicpatterns.com/uploads/qmsajrr5P6VNoaJuJWNXPe/Captura_de_pantalla_2026-04-17_a_la(s)_6.21.35_p.m..png" alt="Mímate Studio Logo" className="h-12 object-contain rounded-full mb-4 opacity-90" data-id="element-49" />
        <p className="text-mimate-bg/70 text-sm" data-id="element-50">
          © 2024 Mímate Studio. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}